import React from 'react';
import download from './img/file-download-line.png'
import api from './apiConnector'

class Documents extends React.Component {

    constructor(props) {
        super(props)
        this.state = { waiting:false }
    }


    render() {
        return <React.Fragment>
                    {this.props.devis.documents.map(doc =>
                    <a className="document_download" key={doc.name} href={api.downloadDocument( this.props.devis.typedId(), doc.name )} target="_blank">
                          <img src={download}/> {doc.name}
                    </a>)}
        </React.Fragment>
    }
}

export default Documents;